<template>
  <div class="adaptive-progressive-img">
    <!-- XtraLarge-->
    <progressive-img
      :src="xlrg"
      :placeholder="placeholder"
      :fallback="placeholder"
      class="xlrg"/>
    <!-- Large -->
    <progressive-img
      :src="lrg"
      :placeholder="placeholder"
      :fallback="placeholder"
      class="lrg"/>
    <!-- Medium-->
    <progressive-img
      :src="med"
      :placeholder="placeholder"
      :fallback="placeholder"
      class="med"/>
    <!-- Small-->
    <progressive-img
      :src="sm"
      :placeholder="placeholder"
      :fallback="placeholder"
      class="sm"/>
  </div>
</template>
<script>
import placeholder from '../assets/images/placeholder.png';

export default {
  name: 'AdaptiveProgressiveImage',
  components: {
  },
  props: {
    xlrg: {
      type: String,
      default: placeholder,
    },
    lrg: {
      type: String,
      default: placeholder,
    },
    med: {
      type: String,
      default: placeholder,
    },
    sm: {
      type: String,
      default: placeholder,
    },
    // Use src if you have only 1 img available for all screen sizes
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      placeholder,
    };
  },
};
</script>
<style lang="scss" scoped>
$xlrg : 1440px;
$lrg: 1024px;
$md: 768px;
$sm: 576px;

.adaptive-progressive-img {
  .xlrg,.lrg,.med,.sm {
    margin-top: 25px;
    display: none;
  }
}
@media (min-width: $lrg) {
  .adaptive-progressive-img {
    .xlrg {
      display: block !important;
    }
  }
}
@media (min-width: $md) and (max-width: $lrg) {
  .adaptive-progressive-img {
    .lrg {
      display: block;
    }
  }
}
@media (min-width: $sm) and (max-width: $md) {
  .adaptive-progressive-img {
    .med {
      display: block;
    }
  }
}
@media (max-width: $sm) {
  .adaptive-progressive-img {
    .sm {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/AdaptiveProgressiveImage.vue